module.exports = __webpack_public_path__ + "static/make-video-slide1-e1eb39130081371dceac84f57cac5925.png";